
import { ObjectType } from 'phoenix/domain';
import { ToastService } from 'sharebase/services';
import { AuthService } from 'phoenix/services';
import { gettext } from 'angular';
const template = require('./authorizeLinkShare.template');

enum PasswordType {
    CustomPassword = 'Password',
    AccessCode = 'Access Code'
}

export function AuthorizeLinkShareDirective(): ng.IDirective {
    return {
        restrict: 'E',
        controller: AuthorizeLinkShareController,
        controllerAs: 'vm',
        template,
        bindToController: true,
        scope: {
            invalidPassword: '=',
            token: '@',
            itemType: '=',
            itemId: '=',
            recipient: '='
        }
    };
}

export class AuthorizeLinkShareController {
    public static $inject = [
        '$state', 
        'sbToastService',
        'pxAuthService', 
        'gettextCatalog'
    ];

    private invalidPassword: boolean;
    private token: string;
    private itemType: ObjectType;
    private itemId: string;
    private recipient: string;
    public userMessage: string = '';
    public password: string = '';
    public passwordType: PasswordType;
    public linkPassword: any;
    public passwordPlaceholder:string;
    public PasswordType = PasswordType;

    constructor(
        private $state: ng.ui.IStateService,
        private sbToastService: ToastService,
        private pxAuthService: AuthService,
        private gettextCatalog: gettext.gettextCatalog
    ){
        this.passwordType = this.recipient ? PasswordType.AccessCode : PasswordType.CustomPassword;
        this.passwordPlaceholder = this.recipient ? this.gettextCatalog.getString('Access Code') : this.gettextCatalog.getString('Password');

        if (this.recipient && this.invalidPassword){
            this.userMessage = this.gettextCatalog.getString('Incorrect access code entered');
        } else if (this.invalidPassword){
            this.userMessage = this.gettextCatalog.getString('Incorrect password entered');
        } else if (this.recipient) {
            this.requestAccessCode();
        }
    }

    public gotoLogin(){
        this.$state.go('login');
    }

    public requestAccessCode(){
        this.pxAuthService
            .requestAccessCode(this.itemType, this.token, this.recipient)
            .then(() => {
                this.sbToastService.showSimple(this.gettextCatalog.getString('A new access code has been sent to the email address on record for this share.'));
            })
            .catch(() => {
                this.userMessage = this.gettextCatalog.getString('Could not request access code');
            });
    }

    public submitPassword(){
        if (!this.linkPassword.$valid) { return;}

        let params:any = {
            password: this.password,
            token: this.token
        };
        let state = '';
        if(this.recipient){
            params.recipient = this.recipient;
        }

        switch(this.itemType) {                        
            case ObjectType.DOCUMENT: 
                state = 'content.myFiles.document.share';
                params.docID = this.itemId;
                break;
            case ObjectType.FOLDER:
                state = 'content.myFiles.folder.share';
                params.folderID = this.itemId;
                break;
            default:
                state = 'login';
                params = {
                    errorMessage : this.gettextCatalog.getString('Link authorization failed.')
                };
                break;
        }

        this.$state.go(state, params);
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/authorizeLinkShare/authorizeLinkShare.ts